import $ from 'jquery';

export default () => {
  if ($('.newsletter-form').length > 0) {
    const form = $('.newsletter-form');

    form.find('input').keypress(function (e) {
      if (e.which == 10 || e.which == 13) {
        $('#button-addon2').trigger('click');
      }
    });

    let isRtl = $("html").attr("dir") === "rtl";
    let culture = 'en';
    if (isRtl) {
      culture = 'ar';
    }
    form.find('#button-addon2').on('click', function () {
      const email = form.find('#emailInput').val();
      const inputFieldMailRegex = (/^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      var loadingImg = form.find('[data-sf-role="loading-img"]');


      if (!inputFieldMailRegex.test(email)) {
        form.find('.invalid-feedback').show();
        return;
      } else {
        form.find('.invalid-feedback').hide();
      }

      loadingImg.show();
      form.find('.js-form').hide();

      $.post({
        url: '/api/NewsletterService/AddSubscriber',
        data: {
          '__RequestVerificationToken': $('.newsletter-form input[name=__RequestVerificationToken]').val(),
          culture,
          email
        }
      }).done((data) => {
        loadingImg.hide();
        form.find('.js-form').show();

        let message;
        if (data.Message == "Invalid") {
          form.find('.invalid-feedback').show();
          return;
        }
        if (data.Message == "Error") {
          message = form.find('.js-messages').attr('data-errorMessage');
        }
        if (data.Message == "Success") {
          message = form.find('.js-messages').attr('data-sucessMessage');
        }

        form.find('.js-form').hide();
        form.find('.js-messages').show();
        form.find('.js-messages p').text(message);

      }).fail(() => {
        loadingImg.hide();
        form.find('.invalid-feedback').show();
      });
    });

    form.on('submit', function (e) {
      e.preventDefault();
    });
  }
};
